import React from "react";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navbar-top d-flex justify-content-end">
      <Nav activeKey="/" className="d-none d-md-flex">
        <Nav.Item>
          <Nav.Link
            as={Link}
            to={{
              pathname: "/",
              hash: "#libros",
            }}
          >
            Libros
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to={{
              pathname: "/",
              hash: "#libros-minedu",
            }}
          >
            Libros MINEDU
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to={{
              pathname: "/",
              hash: "#recursos",
            }}
          >
            Recursos
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to={{
              pathname: "/",
              hash: "#webinars",
            }}
          >
            Webinars
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default Navbar;
